import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import './Accordion.css'; // Add your custom styles here

const Accordion = ({ questions, className="" }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleClick = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="accordion border-none">
            {questions.map((item, index) => (
                <div key={index} className="accordion-item">
                    <div
                        className={`accordion-question ${className}`}
                        onClick={() => handleClick(index)}
                    >
                        <h4 className=' d-flex'><span className='pe-3'>{index+1}.</span> {item.question}</h4>
                        <div>
                            <i className={`bi bi-plus ${activeIndex === index ? 'rotate' : ''} fs-1`}> </i>
                            {/* {activeIndex === index ? <i className='bi bi-x fs-2'></i> : <i className='bi bi-plus fs-2'></i>} */}
                        </div>
                    </div>

                    <CSSTransition
                        in={activeIndex === index}
                        timeout={300}
                        classNames="accordion-content"
                        unmountOnExit
                    >
                        <div className="accordion-answer">
                            <p>{item.answer}</p>
                        </div>
                    </CSSTransition>
                </div>
            ))}
        </div>
    );
};

export default Accordion;
